import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../hooks/common/useAuth';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../constants/service/common/userPermissions';
import { SynonymRuleWorkspace } from '../../views/searchDictionary/components/SynonymRuleWorkspace';

/** 등록(`/synonyms/new`)과 상세(`/synonyms/:id`)가 같은 화면이다 — id 가 없으면 등록 */
export const SearchDictionaryRuleContainer = (): React.JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const { can } = useAuth();
  const subject = PERMISSION_SUBJECTS.SEARCH_DICTIONARY;
  return (
    <SynonymRuleWorkspace
      ruleId={id}
      canRead={can(PERMISSION_ACTIONS.READ, subject)}
      canCreate={can(PERMISSION_ACTIONS.CREATE, subject)}
      canUpdate={can(PERMISSION_ACTIONS.UPDATE, subject)}
      canDelete={can(PERMISSION_ACTIONS.DELETE, subject)}
    />
  );
};
